import { fileViewerStore } from '../Stores/FileViewerStore'

/**
 * Відкрити файл диска в глобальному переглядачі поверх поточного екрана —
 * з будь-якого модуля (чат, картки CRM). Адреса сторінки не змінюється;
 * «попередній/наступний» гортає файли його папки, Esc закриває.
 *
 * `admin: true` — з адмін-панелі диска: вміст за адмінським посиланням
 * (`content_url?admin=1`) із записом кожного відкриття в журнал
 * адміністратора (`DISK-006` §2.3).
 */
export const openDiskFile = (uuid: string, options: { admin?: boolean } = {}): void =>
    fileViewerStore.open(uuid, options.admin === true ? { admin: true } : {})
